// extracted by mini-css-extract-plugin
module.exports = {"video":"HomePageHowItWorksVideo_video__S2jCs"};